<template>
<div class=''>
	<div class='left'> <router-link to="/"><span class="material-icons">chevron_left</span></router-link>  </div> 
	<h6 class='heading'>Instajob</h6>
	
	<div class="overlay">私のこと</div>
</div>
</template>

<script>
export default {

 data () {
   return {
	accordion: false,
    active:""
   }
 },

   
  
  methods: {
    showAccordion: function(){
      if(this.accordion == false) this.nextElementSibling = true
      else this.accordion = false
    }
  },

}
</script>

<style lang="sass">
	
</style>